module.exports = {
      id: "scripted-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#scripted",
      toString: function () {
        return this.url;
      }
    }